
import { Policy } from "@/types";

/**
 * Operations related to policy access and ownership
 */
export const usePolicyAccess = (
  policies: Policy[],
  user: any
) => {
  const isUserPolicyOwner = (policyId: string) => {
    if (!user) return false;
    
    const policy = policies.find(p => p.id === policyId);
    
    console.log("isUserPolicyOwner check:", {
      policyId,
      ownerId: policy?.ownerId,
      userId: user.id,
      isOwner: policy?.ownerId === user.id,
      userObj: user
    });
    
    return policy?.ownerId === user.id;
  };

  const canUserViewDrafts = () => {
    if (!user) return false;
    return user.isAdmin || user.role === 'admin' || policies.some(policy => isUserPolicyOwner(policy.id));
  };

  const getDraftPolicies = () => {
    if (!canUserViewDrafts()) return [];
    return policies.filter(policy => policy.isDraft);
  };

  const getPublishedPolicies = () => {
    return policies.filter(policy => !policy.isDraft && !policy.isArchived);
  };

  const getArchivedPolicies = () => {
    return policies.filter(policy => policy.isArchived);
  };

  return {
    isUserPolicyOwner,
    canUserViewDrafts,
    getDraftPolicies,
    getPublishedPolicies,
    getArchivedPolicies
  };
};
